import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Button } from '@common/components/Button';
import { I18n } from 'react-redux-i18n';
import mapValues from 'lodash/mapValues';

import Dropdown from '@common/containers/fields/Dropdown';
import Settings from './Settings';
import ProfileFormatsManagement from '../containers/ProfileFormatsManagement';
import { NONE_PROFILE_FORMAT } from '../const/UserMaintenance';
import { isEmail } from '@common/utils/email';

import '../styles/UserDetails.scss';

export default class UserDetails extends Component {
    state = {
        isOpenSettings: false,
        isOpenProfileFormatsManagement: false,
    }

    constructor(props) {
        super(props);

        this.props.funcLoadProfiles();
    }

    get quickControls() {
        return [
            { label: this.state.isOpenSettings ? I18n.t('Hide Settings') : I18n.t('Show settings'), onClick: this.onToggleSettingsState, elementId: 'btn-ud-settings' },
            { label: I18n.t('Change Password'), onClick: this.onChangePasswordClick, elementId: 'btn-ud-chg-password' },
            { label: I18n.t('Delete User'), onClick: this.onDeleteUserClick, elementId: 'btn-ud-delete-user' },
        ];
    }

    get styles() {
        return {
            labelWrapper: {
                width: '100px',
            },
            inputWrapper: {
                width: '240px',
            }
        };
    }

    get errors() {
        const { user } = this.props;

        const rules = {
            email: [
                {
                    condition: user.email && !isEmail(user.email),
                    message: I18n.t('Please enter a valid email'),
                }
            ],
        };

        return mapValues(
            rules,
            (value) => {
                return value.filter((x) => x.condition);
            }
        );
    }

    onDeleteUserClick = () => {
        const { user, onDeleteUserClick } = this.props;
        onDeleteUserClick(user.username)
    }

    onChangePasswordClick = () => {
        const { user, onChangePasswordClick } = this.props;
        onChangePasswordClick(user.username)
    }

    onFirstNameChange = (e) => {
        this.props.onUpdateInput('firstname', e.target.value)
    }

    onLastNameChange = (e) => {
        this.props.onUpdateInput('lastname', e.target.value)
    }

    onEmailChange = (e) => {
        this.props.onUpdateInput('email', e.target.value)
    }

    onFirstName = (e) => {
        this.props.onUpdateProperty(this.props.user.username, 'firstname', e.target.value)
    }

    onLastName = (e) => {
        this.props.onUpdateProperty(this.props.user.username, 'lastname', e.target.value)
    }

    onLocked = (e) => {
        this.props.onUpdateInput('locked', e.target.checked);
        this.props.onUpdateProperty(this.props.user.username, 'locked', e.target.checked)
    }

    onEmail = (e) => {
        if (!this.errors.email.length) {
            this.props.onUpdateProperty(this.props.user.username, 'email', e.target.value)
        }
    }

    onProfileFormat = (val) => {
        const finalValue = val == NONE_PROFILE_FORMAT ? '' : val;

        this.props.onUpdateProperty(this.props.user.username, 'profilename', finalValue)
    }

    onAdmin = (e) => {
        this.props.onUpdateInput('admin', e.target.checked);
        this.props.onUpdateProperty(this.props.user.username, 'admin', e.target.checked)
    }

    onEndUserAdministrator = (e) => {
        this.props.onUpdateInput('enduseradmin', e.target.checked);
        this.props.onUpdateProperty(this.props.user.username, 'enduseradmin', e.target.checked)
    }

    onToggleSettingsState = () => {
        this.setState((state) => ({ isOpenSettings: !state.isOpenSettings }));
    }

    openProfileFormatsManagement = () => {
        this.setState((state) => ({ ...state, isOpenProfileFormatsManagement: true }));
    }

    closeProfileFormatsManagement = () => {
        this.setState((state) => ({ ...state, isOpenProfileFormatsManagement: false }));
    }

    render() {
        let styles = {
            container: (base, state) => ({
                ...base,
                height: '34px',
                paddingBottom: '6px '
            }),
            control: (base, state) => {
                let borderColor = state.isFocused ? '#66afe9' : '#ccc';
                return {
                    ...base,
                    height: '34px',
                    minHeight: '34px',
                    padding: '0px 3px',
                    backgroundColor: '#fff',
                    borderColor: borderColor
                }},
            indicatorSeparator: (base, state) => ({
                ...base,
                display: 'none'
            }),
            option: (base, state) => {
                let bc = '#fff';
                if (state.isFocused || state.isSelected) {
                    bc = '#eeeeee'
                }
                return {
                    ...base,
                    color: '#333',
                    height: '24px',
                    minHeight: '24px',
                    backgroundColor: bc,
                    padding: '3px 10px'
                }
            }
        };
        const { profileFormats, user, user: { profileFormat, username, firstName, admin, lastName, email, locked, endUserAdmin }, settingsMethods } = this.props;
        const disabled = !username;
        const lockDisabled = disabled || username == 'progeny';
        const normalizedProfileFormats = [NONE_PROFILE_FORMAT, ...profileFormats.map(({ name }) => name)];
        const shouldDisableTab = Boolean(profileFormat);
        
        return (
            <div className='details-container User-details'>
                {this.state.isOpenProfileFormatsManagement && (
                    <ProfileFormatsManagement 
                        user={user}
                        formats={profileFormats}
                        close={this.closeProfileFormatsManagement} 
                    />
                )}
                <div className='row User-details__row'>
                    <div id="lbl-ud-first-name" className='col-md-2 col-sm-1 User-details__row__label-wrapper' style={this.styles.labelWrapper}><label>{I18n.t('First Name')}</label></div>
                    <div className='col-md-3 col-sm-4' style={this.styles.inputWrapper}>
                        <input id="tx-ud-first-name" type='text' className='form-control' value={firstName} tabIndex="1" disabled={disabled} onBlur={this.onFirstName} onChange={this.onFirstNameChange}/>
                    </div>
                    <div className='col-md-4 User-details__row__checkboxes'>
                        <div className='cb-container'>
                            <input type='checkbox' id='cb-locked' checked={locked} tabIndex="8" disabled={lockDisabled} onChange={this.onLocked}/>
                            <label id="lbl-ud-locked" htmlFor='cb-locked'>{I18n.t('Locked')}</label>
                        </div>
                        <div className='cb-container'>
                            <input type='checkbox' id='cb-admin' checked={admin} tabIndex="7" disabled={disabled} onChange={this.onAdmin}/>
                            <label id='lbl-cb-admin' htmlFor='cb-admin'>{I18n.t('Administrator')}</label>
                        </div>
                        <div className='cb-container'>
                            <input type='checkbox' id='cb-endUserAdmin' checked={endUserAdmin} tabIndex="6" disabled={disabled || admin} onChange={this.onEndUserAdministrator}/>
                            <label id='lbl-cb-endUserAdmin' htmlFor='cb-endUserAdmin'>{I18n.t('End User Administrator')}</label>
                        </div>
                    </div>
                </div>
                <div className='row User-details__row'>
                    <div id="lbl-ud-last-name" className='col-md-2 col-sm-1 User-details__row__label-wrapper' style={this.styles.labelWrapper}><label>{I18n.t('Last Name')}</label></div>
                    <div className='col-md-3 col-sm-4' style={this.styles.inputWrapper}>
                        <input id="tx-ud-last-name" type='text' className='form-control' value={lastName} tabIndex="2" disabled={disabled} onBlur={this.onLastName} onChange={this.onLastNameChange}/>
                    </div>
                </div>
                <div className='row User-details__row'>
                    <div id="lbl-ud-email" className='col-md-2 col-sm-1 User-details__row__label-wrapper' style={this.styles.labelWrapper}><label>{I18n.t('Email')}</label></div>
                    <div className='col-md-3 col-sm-4' style={this.styles.inputWrapper}>
                        <input id="tx-ud-email" type='email' className='form-control' value={email} tabIndex="3" disabled={disabled} onBlur={this.onEmail}  onChange={this.onEmailChange}/>
                        {this.errors.email.length 
                            ? <div className="User-details__error">{this.errors.email[0].message}</div>
                            : null
                        }
                    </div>
                </div>
                <div className='row User-details__row'>
                    <div id="lbl-ud-profile-fmt" className='col-md-2 col-sm-1 User-details__row__label-wrapper' style={this.styles.labelWrapper}><label>{I18n.t('Profile Format')}</label></div>
                    <div className='col-md-3 col-sm-4' style={this.styles.inputWrapper}>
                        <Dropdown
                            id="profileFormat"
                            styles={styles}
                            selectedValue={profileFormat || NONE_PROFILE_FORMAT}
                            searchable={false}
                            options={normalizedProfileFormats}
                            tabIndex={4}
                            onValueChanged={this.onProfileFormat}
                            disabled={disabled || admin}
                        />
                    </div>
                    <Button id="btn-ud-profile-manage" className="User-details__manage-button" onClick={this.openProfileFormatsManagement}>{I18n.t('Manage')}</Button>
                </div>
                <div className="User-details__quick-controls">
                    {this.quickControls.map(({ label, onClick, elementId }) => (
                        <Button id={elementId} key={label} onClick={onClick} disabled={elementId == 'btn-ud-delete-user' && lockDisabled}>
                            {label}
                        </Button>
                    ))}
                </div>
                {this.state.isOpenSettings && (
                    <div className="User-details__settings-wrapper">
                        <hr />
                        <Settings 
                            data={user}
                            tabsToDisable={{
                                security: shouldDisableTab,
                                licensing: shouldDisableTab,
                                formats: shouldDisableTab,
                                ambryIDs: false,
                            }}
                            methods={settingsMethods}
                        />
                    </div>
                )}
            </div>
        )
    }
}

UserDetails.propTypes = {
    user: PropTypes.shape({
        username: PropTypes.string,
        firstName: PropTypes.string,
        lastName: PropTypes.string,
        email: PropTypes.string,
        profileFormat: PropTypes.string,
        locked: PropTypes.bool,
        webClient: PropTypes.bool,
        webAdmin: PropTypes.bool,
        ambryIDs: PropTypes.array
    }),
    profileFormats: PropTypes.arrayOf(PropTypes.object),
    onUpdateProperty: PropTypes.func,
    onUpdateInput: PropTypes.func,
    funcLoadProfiles: PropTypes.func,
    onDeleteUserClick: PropTypes.func,
};